import { render } from "./AnalyticsNotesForeignTradeTextMonthly.vue?vue&type=template&id=ad59f08e&ts=true"
import script from "./AnalyticsNotesForeignTradeTextMonthly.vue?vue&type=script&lang=ts"
export * from "./AnalyticsNotesForeignTradeTextMonthly.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__